import { TDropdown } from '@variantjs/vue';

const styles = {
    dropdownWrapper: 'relative',
    dropdown: 'absolute bg-white pt-20px pb-25px shadow-08 top-8px -right-5px rounded w-262px',
    enterClass: 'opacity-0 scale-95',
    enterActiveClass: 'transition transform ease-out duration-100',
    enterToClass: 'opacity-100 scale-100',
    leaveClass: 'opacity-100 scale-100',
    leaveActiveClass: 'transition transform ease-in duration-75',
    leaveToClass: 'opacity-0 scale-95',
};

const settings = {
    TDropdown: {
        component: TDropdown,
        props: {
            classes: styles,
        },
    },
};

export default settings;
